// Single source of truth for DBS restricted residence countries
// country: full name as returned by userInfo API (uppercased)
// countryCode: ISO alpha-2 code used in SWIFT code positions 4-5
export const DBS_RESTRICTED_COUNTRIES = [
  { country: 'CHINA', countryCode: 'CN' },
  { country: 'ALGERIA', countryCode: 'DZ' },
  { country: 'BANGLADESH', countryCode: 'BD' },
  { country: 'EGYPT', countryCode: 'EG' },
  { country: 'IRAQ', countryCode: 'IQ' },
  { country: 'MOROCCO', countryCode: 'MA' },
  { country: 'NEPAL', countryCode: 'NP' },
  { country: 'QATAR', countryCode: 'QA' },
  { country: 'TUNISIA', countryCode: 'TN' },
] as const

// Derived arrays for call-site convenience
export const DBS_RESTRICTED_RESIDENCE_COUNTRIES: string[] = DBS_RESTRICTED_COUNTRIES.map(
  (c) => c.country
)
export const DBS_RESTRICTED_COUNTRY_CODES: string[] = DBS_RESTRICTED_COUNTRIES.map(
  (c) => c.countryCode
)
